'use strict';



export default function refreshAll () {
    if ( window.oData.csrf_baptist ) {
        const host = window.location.host.substr(0, 4) === 'www.'
                    ? window.location.host.substr(4)
                    : window.location.host;

        const url = `${window.location.protocol}//cache.${host}`;
        window.fetch(`${url}/ajax/Main/cachRefreshAll?csrf_baptist=${window.oData.csrf_baptist}`);
    }
}


function getTypeByController (controller) {
  switch (controller) {
    case 'Vertalingen':
      return 'translations';
    break;

    case 'Combi':
    case 'Newproduct':
    case 'Limited':
    case 'Categories':
    case 'Subcategory':
      return 'products';
    break;
  }
}


export function deleteByController () {
  if (!window.sController) return;

  const type = getTypeByController(window.sController);

  if ( type ) {
    deleteByType(type);
  }
}


export function deleteByType (type = '') {
  if ( window.oData.csrf_baptist ) {
        const host = window.location.host.substr(0, 4) === 'www.'
                    ? window.location.host.substr(4)
                    : window.location.host;

        if ( type !== '' ) {
          type = '/' + type;
        }

        const baseUrl = `${window.location.protocol}//cache.${host}`;
        const url = `${baseUrl}/ajax/Main/deleteCache${type}?csrf_baptist=${window.oData.csrf_baptist}`

        window.fetch(url);
    }
}
